export var getProductId = function getProductId(product) {
  return (product == null ? void 0 : product.variationId) || (product == null ? void 0 : product.id);
};